import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from '@phosphor-icons/react';
import { Badge } from 'components/ui/badge';

interface PipelineColumnProps {
  title: string;
  count: number;
  accentClass: string;
  headerBgClass: string;
  children: ReactNode;
  emptyMessage?: string;
  navigateTo?: string;
}

export const PipelineColumn = ({
  title,
  count,
  accentClass,
  headerBgClass,
  children,
  emptyMessage = 'Geen units in deze fase',
  navigateTo,
}: PipelineColumnProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col w-[300px] flex-shrink-0 bg-neutral-secondary-light rounded-lg overflow-hidden">
      <div className={`flex items-center justify-between px-3 py-2.5 ${headerBgClass}`}>
        <span className={`text-sm font-medium ${accentClass}`}>{title}</span>
        <div className="flex items-center gap-1.5">
          <Badge
            variant="secondary"
            className={`text-xs h-5 min-w-5 px-1.5 font-medium ${accentClass} bg-white/60`}
          >
            {count}
          </Badge>
          {navigateTo && (
            <button
              onClick={() => navigate(navigateTo)}
              className={`h-5 w-5 flex items-center justify-center rounded hover:bg-white/60 transition-colors ${accentClass}`}
            >
              <ArrowRight size={12} weight="bold" />
            </button>
          )}
        </div>
      </div>
      <div className="flex flex-col gap-2 p-2 overflow-y-auto flex-1 max-h-[calc(100vh-220px)]">
        {count === 0 ? (
          <div className="flex items-center justify-center py-8 text-neutral-secondary-mid text-xs text-center px-4">
            {emptyMessage}
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
};
